import { Box, Button, MenuItem, Select, SelectChangeEvent, Tab, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Tabs, TextField } from "@mui/material";
import { useNavigate } from "react-router-dom";
import SearchBar from "../../components/SearchBar";
import { useState } from "react";
import SwitchToggle from "../../components/SwitchToggle";
import React from "react";

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function CustomTabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <>{children}</>}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const ManageQrCode = () => {

  const navigate = useNavigate();
  const [searchTerm, setSearchTerm] = useState("");
  const [valueTabs, setValueTabs] = useState(0);
  const handleChangeTabs = (event: React.SyntheticEvent, newValue: number) => {
    setValueTabs(newValue);
  };

  const [refreshInterval, setRefreshInterval] = useState("60");
  const [validityWindow, setValidityWindow] = useState("5");
  const [tokenRules, setTokenRules] = useState("");
  const [Status, setStatus] = React.useState('default');

  const [records] = useState([
    {
      id: 1,
      user: "John Doe",
      email: "johndoe@gmail.com",
      phone: "+91 9876543210",
      time: "03-Sep-2025 10:15 AM",
      action: "Earned",
      value: "50 Points",
    },
    {
      id: 2,
      user: "Jane Smith",
      email: "janesmith@gmail.com",
      phone: "+91 9876543210",
      time: "03-Sep-2025 10:20 AM",
      action: "Redeemed",
      value: "50 Points",
    },
    {
      id: 3,
      user: "Robert Lee",
      email: "robertlee@gmail.com",
      phone: "+91 9876543210",
      time: "03-Sep-2025 11:00 AM",
      action: "Earned",
      value: "20 Points",
    },
  ]);

  return (
    <>
      <div className="main_title">
        <h1>QR Code Management</h1>
        <p>
          <button onClick={() => navigate("/dashboard")}>Dashboard</button> - QR Code Management
        </p>
      </div>

      <div className="table_header">
        <div className="left_s">
          <Box className="custom_tabs1" sx={{ width: "100%" }}>
            <Tabs
              value={valueTabs}
              onChange={handleChangeTabs}
              aria-label="basic tabs example"
              className="custom_tabs_links"
            >
              <Tab label="QR Code Settings" {...a11yProps(0)} />
              <Tab label="Last Used Records" {...a11yProps(1)} />
            </Tabs>
          </Box>
        </div>
      </div>

      <div className="cards">
        <CustomTabPanel value={valueTabs} index={0}>
          <form className="form" action="">
            <div className="gap_p">
              <div className="control_group w_33">
                <label htmlFor="refresh_interval">Refresh Interval</label>
                <Select
                  id="refresh_interval"
                  value={refreshInterval}
                  onChange={(e: SelectChangeEvent) =>
                    setRefreshInterval(e.target.value)
                  }
                  fullWidth
                >
                  <MenuItem value="30">Every 30s</MenuItem>
                  <MenuItem value="60">Every 60s</MenuItem>
                  <MenuItem value="120">Every 2 mins</MenuItem>
                </Select>
              </div>

              <div className="control_group w_33">
                <label htmlFor="validity_window">Validity Window</label>
                <Select
                  id="validity_window"
                  value={validityWindow}
                  onChange={(e: SelectChangeEvent) =>
                    setValidityWindow(e.target.value)
                  }
                  fullWidth
                >
                  <MenuItem value="1">1 min</MenuItem>
                  <MenuItem value="5">5 mins</MenuItem>
                  <MenuItem value="10">10 mins</MenuItem>
                </Select>
              </div>

              <div className="control_group w_33">
                <label htmlFor="token_rules">Token Generation Rules</label>
                <TextField
                  id="token_rules"
                  placeholder="e.g., Random UUID, SHA256"
                  value={tokenRules}
                  onChange={(e) => setTokenRules(e.target.value)}
                  fullWidth
                  hiddenLabel
                />
              </div>

              <div className="control_group flex w_33">
                <label htmlFor="token_disable">Disable expired tokens</label>
                <SwitchToggle />
              </div>
            </div>
            <div className="form_btn">
              <Button className="btn btn_primary">Submit</Button>
            </div>
          </form>
        </CustomTabPanel>
        <CustomTabPanel value={valueTabs} index={1}>
          <div className="table_header">
            <div className="left_s">
              <SearchBar
                searchTerm={searchTerm}
                setDebouncedSearchTerm={setSearchTerm}
                placeholder="Search..."
              />
              <div className=" form">
                <Select
                  fullWidth
                  value={Status}
                  onChange={(e: SelectChangeEvent) =>
                    setStatus(e.target.value)
                  }>
                  <MenuItem disabled value="default">Select Status</MenuItem>
                  <MenuItem value="All">All</MenuItem>
                  <MenuItem value="Earned">Earned</MenuItem>
                  <MenuItem value="Redeemed">Redeemed</MenuItem>
                </Select>
              </div>
            </div>
          </div>
          <TableContainer className="table_container">
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>User</TableCell>
                  <TableCell>Time</TableCell>
                  <TableCell>Loyalty Points</TableCell>
                  <TableCell>Status</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {records.map((record) => (
                  <TableRow hover key={record.id}>
                    <TableCell>
                      <a
                        href="/manage-users/detail"
                        onClick={(e) => {
                          e.preventDefault();
                          navigate("/manage-users/detail");
                        }}
                        className="user_block click_action"
                      >

                        <p>
                          <b>{record.user}</b>
                          <span>{record.email}</span>
                          <span>{record.phone}</span>
                        </p>
                      </a>
                    </TableCell>
                    <TableCell>{record.time}</TableCell>
                    <TableCell>{record.value}</TableCell>
                    <TableCell>
                      <span
                        className={`status_btn ${record.action === "Earned"
                          ? "c_success"
                          : record.action === "Redeemed"
                            ? "c_danger"
                            : ""
                          }`}
                      >
                        {record.action}
                      </span>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </CustomTabPanel>
      </div>
    </>
  );
};

export default ManageQrCode;
